var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"info-page-container"},[_c('container',{staticClass:"info-page-container__body"},[_c('div',{staticClass:"info-page-container__logo"},[_c('logo',{staticClass:"auth-logo"})],1),_c('div',{staticClass:"info-page-container__content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }